import _slicedToArray from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var ReactPropToAttrNameMap = {
  className: 'class',
  classname: 'class',
  htmlFor: 'for',
  crossOrigin: 'crossorigin',
  viewBox: 'viewBox'
};
export var toNativeAttrName = function toNativeAttrName(propName, propValue) {
  if (ReactPropToAttrNameMap[propName]) return ReactPropToAttrNameMap[propName];
  if (typeof propValue == undefined) return undefined;
  if (typeof propValue === 'boolean' && !propValue) return undefined;
  if (/[A-Z]/.test(propName)) return propName.toLowerCase();
  return propName;
};
export var toNativeAttrValue = function toNativeAttrValue(propValue, _propName) {
  if (typeof propValue === 'boolean') return '';
  if (Array.isArray(propValue)) return propValue.join(' ');
  return propValue;
};
export var toNativeProps = function toNativeProps() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(props).reduce(function (transformedProps, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        propName = _ref2[0],
        propValue = _ref2[1];

    var attrName = toNativeAttrName(propName, propValue); // prop was stripped. Don't add.

    if (!attrName) {
      return transformedProps;
    }

    var attrValue = toNativeAttrValue(propValue, propName);
    transformedProps[attrName] = attrValue;
    return transformedProps;
  }, {});
};